
import { InventoryStateDefinitionModule_systemKey, InventoryBaseState } from "./InventoryStates.js";
import { ToolWithQuantityState } from "./Tool.js";
import { ConsumableState } from "./Consumable.js";
import { map, orElse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export function ofToolState(state) {
    switch (state) {
        case "inMaintenance":
            return new InventoryBaseState(1, []);
        case "retired":
            return new InventoryBaseState(2, []);
        case "lost":
            return new InventoryBaseState(3, []);
        default:
            return new InventoryBaseState(0, []);
    }
}

export function toToolState(baseState) {
    switch (baseState.tag) {
        case 1:
            return "inMaintenance";
        case 2:
            return "retired";
        case 3:
            return "lost";
        default:
            return "active";
    }
}

export function ofSetState(state) {
    switch (state) {
        case "inMaintenance":
            return new InventoryBaseState(1, []);
        case "retired":
            return new InventoryBaseState(2, []);
        case "lost":
            return new InventoryBaseState(3, []);
        default:
            return new InventoryBaseState(0, []);
    }
}

export function toSetState(baseState) {
    switch (baseState.tag) {
        case 1:
            return "inMaintenance";
        case 2:
            return "retired";
        case 3:
            return "lost";
        default:
            return "active";
    }
}

export function ofToolWithQuantityState(state) {
    if (state.tag === 1) {
        return new InventoryBaseState(2, []);
    }
    else {
        return new InventoryBaseState(0, []);
    }
}

export function tryToToolWithQuantityState(baseState) {
    switch (baseState.tag) {
        case 2:
            return new ToolWithQuantityState(1, []);
        case 1:
        case 3:
            return undefined;
        default:
            return new ToolWithQuantityState(0, []);
    }
}

export function ofConsumableState(state) {
    if (state.tag === 1) {
        return new InventoryBaseState(2, []);
    }
    else {
        return new InventoryBaseState(0, []);
    }
}

export function tryToConsumableState(baseState) {
    switch (baseState.tag) {
        case 2:
            return new ConsumableState(1, []);
        case 1:
        case 3:
            return undefined;
        default:
            return new ConsumableState(0, []);
    }
}

function targetKey(stateKey, baseState) {
    return orElse(stateKey, map(InventoryStateDefinitionModule_systemKey, baseState));
}

export function toolTargetKey(dto) {
    return targetKey(dto.StateKey, map(ofToolState, dto.NewState));
}

export function setTargetKey(dto) {
    return targetKey(dto.StateKey, map(ofSetState, dto.NewState));
}

export function toolWithQuantityTargetKey(dto) {
    return targetKey(dto.StateKey, map(ofToolWithQuantityState, dto.NewState));
}

export function consumableTargetKey(dto) {
    return targetKey(dto.StateKey, map(ofConsumableState, dto.NewState));
}

